export default __webpack_public_path__ + "static/calligraphy-cut-240851d83a809e51d9bc750fbd1919de.jpg";